var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { getChildrenByTypeDeep, removeChildrenByTypeDeep } from 'react-nanny';
import { getAutomation, getDebug, useCitrusDebug } from '@citrus/runtime';
import { useTheme } from '@citrus/user';
import { Footer } from './Modal.styled';
import { iif } from '@pcty/utils';
import { StackableButtonGroup } from '@citrus/button';
var VERSION = '5.9.0';
/** DISPLAY NAME: &lt;Modal.Footer&gt; */
var ModalFooter = function (_a) {
    var automationId = _a.automationId, children = _a.children, _b = _a.__TYPE, __TYPE = _b === void 0 ? 'ModalFooter' : _b, other = __rest(_a, ["automationId", "children", "__TYPE"]);
    var citrus2022 = useTheme().citrus2022;
    var primary = getChildrenByTypeDeep(children, ['PrimaryButton']);
    var secondary = getChildrenByTypeDeep(children, ['SecondaryButton']);
    var borderless = getChildrenByTypeDeep(children, ['BorderlessButton']);
    var defaultButton = getChildrenByTypeDeep(children, ['DefaultButton']);
    var nonButtonChildren = removeChildrenByTypeDeep(children, [
        'PrimaryButton',
        'SecondaryButton',
        'BorderlessButton',
        'DefaultButton',
    ]);
    var buttons = [];
    if (citrus2022) {
        buttons = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], borderless, true), secondary, true), defaultButton, true), primary, true);
    }
    else {
        buttons = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], primary, true), defaultButton, true), secondary, true), borderless, true);
    }
    var buttonGroup = React.createElement(StackableButtonGroup, null, buttons);
    var renderFooterLeft = function () { return iif(citrus2022, nonButtonChildren, buttonGroup); };
    var renderFooterRight = function () { return iif(citrus2022, buttonGroup, nonButtonChildren); };
    return (React.createElement(Footer, __assign({}, other, getAutomation(automationId), getDebug(useCitrusDebug(), __TYPE, VERSION)),
        React.createElement("div", null, renderFooterLeft()),
        React.createElement("div", null, renderFooterRight())));
};
ModalFooter.defaultProps = {
    __TYPE: 'ModalFooter',
};
export default ModalFooter;
